import { render, staticRenderFns } from "./ExpensesIntro.vue?vue&type=template&id=14130394&scoped=true&"
import script from "./ExpensesIntro.vue?vue&type=script&lang=js&"
export * from "./ExpensesIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14130394",
  null
  
)

export default component.exports